import $ from 'jquery';

import { debounce, isEmpty } from './utilities';

class GroupManagement {
	constructor(){
		// Check if it's the group management page
		if (this.isGroupManagement()) {
			// Create enrolled users table
			new EnrolledUsersTable();
			new EmailUsers();

			// Setup modal popups
			window.ulgmGroupManagement.groupManagementModal = new modals();
		}
	}

	isGroupManagement(){
		return $( '#group-management' ).length == 1;
	}
}

class modals {
	constructor(){
		$( document ).on( 'modal:open', function ( e ){
			if (e.target.id === 'group-management-email-users') {
				document.dispatchEvent( new CustomEvent( 'uncanny-groups/group-management/email-users/open-options' ) );

				wp.editor.remove( 'group_email_text' );
				wp.editor.initialize( 'group_email_text',
					{
						tinymce: {
							min_height: 300,
							formats: {
								alignleft: [{
									selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li",
									styles: {textAlign: "left"}
								}, {selector: "img,table,dl.wp-caption", classes: "alignleft"}],
								aligncenter: [{
									selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li",
									styles: {textAlign: "center"}
								}, {selector: "img,table,dl.wp-caption", classes: "aligncenter"}],
								alignright: [{
									selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li",
									styles: {textAlign: "right"}
								}, {selector: "img,table,dl.wp-caption", classes: "alignright"}],
								strikethrough: {inline: "del"}
							},
							toolbar1: 'formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | forecolor backcolor emoticons',
							plugins: "charmap colorpicker hr lists media paste tabfocus textcolor fullscreen wordpress wpautoresize wpeditimage wpemoji wpgallery wplink wpdialogs wptextpattern wpview"
						},
						quicktags: {
							buttons: 'strong,em,link,ul,ol,li,code'
						}
					} );
			}
		} );

		// Add events for the group management page
		this.addGroupManagementEvents();
	}

	addGroupManagementEvents(){

		// Clear file so we get a fresh copy every time
		$( "#csv-file" ).on( 'click', function (){
			$( this ).val( '' );
		} );

		// There may be other plugin/themes that are using this modal or using the same trigger. let customize the trigger
		$( 'body' ).on( 'click', '.ulgm-modal-link', this.openModal );

		// User csv file input change
		$( '#csv-file' ).on( 'change', this.parseCsv );

		//Hide inupts dependent on radio
		$( "input:radio[name=action]" ).click( function (){
			var value          = $( this ).val();
			var modalContainer = $( this ).parent();

			modalContainer.children( '#first-name, #last-name, #email, label[for=first-name], label[for=last-name], label[for=email-name]' ).show();
            $('#uo_add_user_password').show();

			if ('send-enrollment' === value || 'add-existing-user' === value) {
				modalContainer.children( '#first-name, #last-name, label[for=first-name], label[for=last-name]' ).hide();
				$('#uo_add_user_password').hide();
			}

		} );

		window.ulgmGroupManagement.downloadCsv = function ( csv ){
			var blob = new Blob( [csv.csvDataString], {type: "text/csv;charset=utf-8"} );
			saveAs( blob, csv.fileName + ".csv" );
		};
	}

	openModal( e ){
		e.preventDefault();

		// clear any error messages
		$( '.group-management-form' ).find( '.group-management-rest-message' ).html( '' ).hide();

		var modalId   = $( this ).data( 'modal-id' );
		var modalAjax = $( this ).data( 'modal-ajax' );

		if (modalAjax == true) {
			var endpoint = $( this ).data( 'endpoint' );
			var user     = $( this ).data( 'user-id' );
			var group    = $( this ).data( 'group-id' );
			var restData = {'action': 'get-user-details', 'user': user, 'group-id': group};
			var spinner  = $( '.uo-modal-spinner' );

			$.ajax( {

				method: "POST",
				url: ulgmRestApiSetup.root + endpoint + '/',
				data: restData,

				// Attach Nonce the the header of the request
				beforeSend: function ( xhr ){
					xhr.setRequestHeader( 'X-WP-Nonce', ulgmRestApiSetup.nonce );
				},

				statusCode: {
					403: function ( xhr ){
						spinner.hide();
						$error_container.html( ulgmRestApiSetup.i18n.youCantDoThat ).show();
					}
				},

				success: function ( response ){

					for (var x in response.data) {
						if ($( '#' + x ).length > 0) {
							$( '#' + x ).val( response.data[x].value );
							if (response.data[x].is_editable == false) {
								$( '#' + x ).attr( 'disabled', 'disabled' );
							}
						}
					}
					spinner.hide();

					if (true === response.success) {
						var modal = $( modalId );

						modal.on( 'modal:open.uncanny-groups-modal', () => {
							// Focus on the first field
							const fieldField = $( modal ).find( 'input:visible, select:visible' ).first();
							
							if ( fieldField.length > 0 ) {
								fieldField.trigger( 'focus' );
							} else {
								$( modal ).find( 'button:visible:first' ).trigger( 'focus' );
							}

							modal.off( 'modal:open.uncanny-groups-modal' );
						} );

						modal.modal();

						$( '#group-management' ).trigger( 'modal-open', [modalId, modal] );
					} else {
						spinner.hide();

						$error_container
							.html( response.data.message )
							.show();
					}
				},

				fail: function ( response ){
					spinner.hide();
					$error_container.html( response.data.message );
				},

			} );

		} else {
			var modal = $( modalId );

			modal.on( 'modal:open.uncanny-groups-modal', () => {
				// Focus on the first field
				const fieldField = $( modal ).find( 'input:visible, select:visible' ).first();
				
				if ( fieldField.length > 0 ) {
					fieldField.trigger( 'focus' );
				} else {
					$( modal ).find( 'button:visible:first' ).trigger( 'focus' );
				}

				modal.off( 'modal:open.uncanny-groups-modal' );
			} );

			modal.modal();

			$( '#group-management' ).trigger( 'modal-open', [modalId, modal] );
		}
	}

	parseCsv( e ){

		var input            = $( this );
		var messageContainer = $( input.closest( '.group-management-form' ) ).find( '.group-management-rest-message' )

		// Reset Message
		messageContainer.hide();
		messageContainer.text( '' );

		try {
			var reader = new FileReader();
			//do something
		} catch (e) {
			messageContainer.text( ulgmGroupManagementLocalized.text.file_api_is_not_supported ).css( 'display', 'inline-flex' );
			return false;
		}

		var file    = $( '#csv-file' )[0].files[0];
		var csvText = false;


		if (file) {
			// check is csv extension
			if ('csv' !== file.name.split( '.' ).pop()) {
				messageContainer.text( ulgmGroupManagementLocalized.text.select_a_csv ).css( 'display', 'inline-flex' );
				return false;
			}

			reader.readAsText( file );

			reader.onload = function ( e ){

				csvText = e.target.result;

				if (!csvText) {
					messageContainer.text( ulgmGroupManagementLocalized.text.csv_file_error ).css( 'display', 'inline-flex' );
					return false;
				}

				// split file text on line breaks
				var csvArray = csvText.split( /\r?\n/g );

				// Preliminary checks

				// Pull out the header and store it

				var csvHead = csvArray.shift();

				let delimiter = ",";
				if (csvHead.indexOf( ";" ) !== -1) {
					delimiter = ";";
				}


				csvHead = csvHead.split( delimiter );

				// Something is off ... create to detect CR only line breaks where CRLF is only supported but may detect other malformations
				if (csvHead.length !== 3 && csvArray.length === 0) {
					messageContainer.text( ulgmGroupManagementLocalized.text.incompatible_format ).css( 'display', 'inline-flex' );
					return false;
				}

				// Remove last line of csv that is always blank
				csvArray.pop();

				// Require emails
				var emailIndex = window.ulgmGroupManagement.groupManagementModal.verifyRequiredHeader( csvHead, 'user_email' );
				if ('error' === emailIndex) {
					messageContainer.text( ulgmGroupManagementLocalized.text.not_contains_email ).css( 'display', 'inline-flex' );
					return false;
				}

				// Require user first name
				var firstNameIndex = window.ulgmGroupManagement.groupManagementModal.verifyRequiredHeader( csvHead, 'first_name' );
				if ('error' === firstNameIndex) {
					messageContainer.text( ulgmGroupManagementLocalized.text.not_contains_first ).css( 'display', 'inline-flex' );
					return false;
				}

				// Require user first name
				var lastNameIndex = window.ulgmGroupManagement.groupManagementModal.verifyRequiredHeader( csvHead, 'last_name' );
				if ('error' === lastNameIndex) {
					messageContainer.text( ulgmGroupManagementLocalized.text.not_contains_last ).css( 'display', 'inline-flex' );
					return false;
				}

				var newArray = csvArray.map( function mapper( v ){
					if (typeof v == "string") {
						return v.split( delimiter );
					} else {
						return v.map( mapper );
					}
				} );


				// Check for blank lines
				var emptyRows = window.ulgmGroupManagement.groupManagementModal.verifyEmptyRows( newArray, emailIndex );

				if (emptyRows) {
					messageContainer.text( ulgmGroupManagementLocalized.text.must_contain_email ).css( 'display', 'inline-flex' );
					return false;
				}

				$( '#csv-text' ).val( csvText );


			};
		} else {
			$( input.closest( '.group-management-form' ) ).find( '.group-management-rest-message' ).text( ulgmGroupManagementLocalized.text.choose_file );
			return false;
		}

	}

	verifyEmptyRows( array, emailIndex ){

		for (var i = 0; i < array.length; ++i) {
			if (array[i][emailIndex] === '') {
				return true;
			}
		}

		return false;

	}

	verifyRequiredHeader( headerArray, type ){

		var columnsAmount = 0;
		var columnIndex   = false;
		for (var i = 0; i < headerArray.length; i++) {
			if (headerArray[i] === type) {
				columnsAmount++;
				columnIndex = i;
			}
		}

		if (0 === columnsAmount) {
			return 'error';

		}

		if (1 !== columnsAmount) {
			return 'error';
		}

		return columnIndex;

	}
}

class EmailUsers {
	constructor() {
		// Listen when the dialog is opened
		this.handleOpenDialog();

		// Listen when the courses and statuses change
		this.handleFieldUpdates();
	}

	/**
	 * Returns the data required to retrieve the number of affected users
	 */
	get emailUsersFormData() {
		return {
			group_id: this.$groupIDHiddenField.value,
			courses: jQuery( this.$coursesDropdown ).val(),
			statuses: jQuery( this.$courseStatuses ).val(),
			include_children: this.$includeChildrenCheckbox ? this.$includeChildrenCheckbox.checked : false,
		}
	}

	/**
	 * Listens to the dialog and updates the user count when it's opened
	 */
	handleOpenDialog() {
		document.addEventListener( 'uncanny-groups/group-management/email-users/open-options', () => {
			// Update the user count
			this.updateUserCount();
		} );
	}

	/**
	 * Listens when the courses and statuses change
	 */
	handleFieldUpdates() {
		// Unfortunately, we need to use jQuery here. select2 doesn't fire the native events
		// https://github.com/select2/select2/issues/4686
		jQuery( this.$coursesDropdown ).on( 'change', () => { this.updateUserCount() } );
		jQuery( this.$courseStatuses ).on( 'change', () => { this.updateUserCount() } );
		// Check if the include children checkbox exists.
		if ( this.$includeChildrenCheckbox ) {
			// Listen to change and update count accordingly.
			jQuery( this.$includeChildrenCheckbox ).on( 'change', () => { this.updateUserCount() } );
		}
	}

	/**
	 * Updates the number of users that'll receive the email
	 */
	updateUserCount() {
		// Remove the current number
		this.$userCountCounter.innerText = '';

		fetch( `${ ulgmRestApiSetup.root }email_users_get_user_count?${ jQuery.param( this.emailUsersFormData ) }`, {
			method: 'GET',
			headers: {
				'X-WP-Nonce': ulgmRestApiSetup.nonce,
			},
		})
			.then( response => response.json() )
			.then( response => {
				if ( ! response.success || typeof response.data.userCount === 'undefined' ) {
					this.$userCountCounter.innerText = `(${ ulgmGroupManagementLocalized.text.error })`;
				}

				this.$userCountCounter.innerText = response.data.userCount;
			} )
			.catch( ( error ) => {
				// Show error
				this.$userCountCounter.innerText = `? (${ ulgmGroupManagementLocalized.text.error })`;
				console.error( error );
			} );
	}

	/**
	 * Returns the node that'll be used to show the user count
	 */
	get $userCountCounter() {
		return document.getElementById( 'ulgm-management-email-users-count' );
	}

	/**
	 * Returns the field "Group courses"
	 */
	get $coursesDropdown() {
		return document.getElementById( 'ulgm-management-send-email-courses' );
	}

	/**
	 * Returns the field "Course status"
	 */
	get $courseStatuses() {
		return document.getElementById( 'ulgm-management-send-email-course-statuses' );
	}

	/**
	 * Returns the hidden field that contains the group ID
	 */
	get $groupIDHiddenField() {
		return document.getElementById( 'group_email_group_id' );
	}

	/**
	 * Returns the include children checkbox if it exists
	 */
	get $includeChildrenCheckbox() {
		let $checkbox = document.getElementById( 'group_email_include_children' );
		return $checkbox !== null ? $checkbox : false;
	}
}

class EnrolledUsersTable {
	constructor(){
		// Check if it has the enrolled users table
		if (this.hasEnrolledUsersTable()) {
			// Get elements
			this.getElements();

			// Get data
			this.getData();

			// Add select2
			this.addSelect2();

			// Create DataTable
			this.createDataTables();

			// Listen the checkbox to select all the users
			this.listenCheckboxToSelectAll();

			// Listen checkboxes changes
			this.listenCheckboxesChanges();

			// Listen modal open and update data
			this.updateDataOnModal();

			// Check if the "First name" and "Last name" fields when adding new users must be required
			this.firstLastNamesRequired();
		}
	}

	getElements(){
		// Get elements
		this.$elements = {
			container: $( '#group-management' ),
			selectEl: $( '.uo-groups select' ),
			enrolledUsersTableDT: $( '#group-management-enrolled-users-datatable' ),
			enrolledLeaderTableDT: $( '#group-management-enrolled-leader-datatable' ),
			removeUsersButton: $( '#group-management-enrolled-users-table-remove-users' ),
			removeLeadersButton: $( '.group-leader-management-buttons' ),
			sendEmailsButton: $( '#group-management-enrolled-users-table-send-password' ),
			numberOfUsers: $( '#group-management .uo-groups-enrolled-users .amount-users' ),
			sendEmailsModal: $( '#group-management-enrolled-users-table-send-password-modal' ),
			sendEmailsField: $( '#group-management-enrolled-users-table-send-password-field' ),
			removeUsersField: $( '#group-management-remove-user #removing-users' ),
			emailUsersCoursesDropdown: $( '#ulgm-management-send-email-courses' ),
		}
	}

	addSelect2(){
		// Init select2 in all dropdowns
		try {
			// Iterate dropdowns
			this.$elements.selectEl.each( ( index, $dropdown ) => {
				// Default select2 options
				const select2Options = {}

				// Check if it's inside a modal
				if ( $dropdown.closest( '.group-management-modal' ) ) {
					// Init select2, but add the main wrapper inside the modal
					select2Options.dropdownParent = $( $dropdown.parentNode );
				}
				
				$( $dropdown ).select2( select2Options );
			} );
		} catch ( e ) {
			console.warn( e );
		}

		if ($( '#group-id' ).length > 0) {
			$( '#group-id' ).change( function (){
				$( this ).closest( 'form' ).submit();
			} );
		}

		// Set logic of the Email users > Courses dropdown
		// Cache the field value. We will use this to see what's the latest selected option
		this.emailUsersCourses = this.$elements.emailUsersCoursesDropdown.val() || [];
		this.$elements.emailUsersCoursesDropdown.on( 'change', () => {

			// Nice-to-have, so let's add it inside a try block
			// Even if this doesn't work, everything else will continue working
			try {
				// Set the value of the "All courses" option
				const optionAllCoursesValue = '-1';

				// Create a variable to know later if we changed the value of the dropdown
				let hadWeChangedCoursesValues = false;

				// Get the values of the dropdown
				let selectedCourses = this.$elements.emailUsersCoursesDropdown.val();

				// Check if there are courses selected
				if ( selectedCourses.length == 0 ) {
					return;
				}

				// Get the latest selected option
				// To do so, get the symmetric difference
				const latestChangedOption = this.emailUsersCourses
					.filter( courseID => ! selectedCourses.includes( courseID ) )
					.concat( selectedCourses.filter( courseID => ! this.emailUsersCourses.includes( courseID ) ) )[0];

				// Check if an option changed
				if ( typeof latestChangedOption === 'undefined' ) {
					return;
				}

				// Check whether the option was added (true) or removed (false)
				const wasLastOptionAdded = this.emailUsersCourses
					.filter( courseID => ! selectedCourses.includes( courseID ) )
					.length == 0;

				// Check if the "All courses" option is selected
				const isOptionAllCoursesSelected = selectedCourses.includes( optionAllCoursesValue );

				if (
					// Check if the user added the "All courses" option
					latestChangedOption == optionAllCoursesValue && wasLastOptionAdded &&
					// And there are more options selected
					selectedCourses.length > 1
				) {
					// Select only "All courses"
					this.$elements.emailUsersCoursesDropdown.val( '' );
					this.$elements.emailUsersCoursesDropdown
						.find( `option[value="${ optionAllCoursesValue }"]` )
						.prop( 'selected', true );

					// We changed the value, update the flag
					hadWeChangedCoursesValues = true;
				}

				if (
					// User added a different option than "All courses"
					latestChangedOption != optionAllCoursesValue && wasLastOptionAdded &&
					// And "All courses" is seleceted
					isOptionAllCoursesSelected
				) {
					// Remove "All courses"
					this.$elements.emailUsersCoursesDropdown
						.find( `option[value="${ optionAllCoursesValue }"]` )
						.prop( 'selected', false );

					// We changed the value, update the flag
					hadWeChangedCoursesValues = true;
				}

				// Check if the value changed
				if ( hadWeChangedCoursesValues ) {
					// Update selected options
					this.emailUsersCourses = this.$elements.emailUsersCoursesDropdown.val();

					// Trigger change event to update select2
					this.$elements.emailUsersCoursesDropdown.trigger( 'change' );
				} 
			} catch ( e ) {
				console.warn( e );
			}
			
		} );
	}

	getData(){
		// Get data from DOM elements
		this.data = {
			canRemoveUsers: !!parseInt( this.$elements.enrolledUsersTableDT.data( 'can-remove-users' ) ),
			canRemoveUsersAnytime: !!parseInt( this.$elements.enrolledUsersTableDT.data( 'can-remove-users-anytime' ) ),
			ulgmGroupLeaderData: null !== ulgmGroupLeaderData ? ulgmGroupLeaderData : [],
		};

		// Set the default array for the selected users on page load
		this.selectedUsers   = [];
		this.selectedLeaders = [];
	}

	createDataTables(){

		/* Create an array with the values of all the input boxes in a column */
		jQuery.fn.dataTable.ext.type.order['uo-groups-anchor-asc'] = function ( a, b ){
			// Create the HTML element
			let textA       = document.createElement( 'div' );
			// Insert the row content inside
			textA.innerHTML = a;
			// Get only the text, not the HTML
			textA           = textA.textContent;
			// Make it lowercase, and remove extra spaces
			textA           = textA.toLowerCase().trim();

			// Now do the same with B
			let textB       = document.createElement( 'div' );
			textB.innerHTML = b;
			textB           = textB.textContent;
			textB           = textB.toLowerCase().trim();

			// Compare text A with text B
			return textA.localeCompare( textB );
		};

		jQuery.fn.dataTable.ext.type.order['uo-groups-anchor-desc'] = function ( a, b ){
			// Create the HTML element
			let textA       = document.createElement( 'div' );
			// Insert the row content inside
			textA.innerHTML = a;
			// Get only the text, not the HTML
			textA           = textA.textContent;
			// Make it lowercase, and remove extra spaces
			textA           = textA.toLowerCase().trim();

			// Now do the same with B
			let textB       = document.createElement( 'div' );
			textB.innerHTML = b;
			textB           = textB.textContent;
			textB           = textB.toLowerCase().trim();

			// Compare text A with text B
			return textB.localeCompare( textA );
		};

		// version 4.0- columns are defined in group-management-interface.php
		let userColumns = this.data.ulgmGroupLeaderData.enrolled_user_columns;

		// Check if we should add the column with the checkbox
		if ( 'true' === this.data.ulgmGroupLeaderData.populate_management_features ) {
			userColumns.unshift( {
				data: 'check',
				title: this.data.ulgmGroupLeaderData.check_all,
				searchable: false,
				orderable: false,
			} );
		}

		// Check if we have to remove the "Key" column
		if ( true !== this.$elements.enrolledUsersTableDT.data( 'key_column' ) ) {
			// Remove it
			userColumns = userColumns.filter( columnData => columnData.targets != 'key' );
		}

		// Create shared options applied to all export buttons
		const buttonCommon = {
			exportOptions: {
				// columns: ':visible'
			},
			filename: () => {
				const filenameParts = [
					'group-management',
					document.getElementById( 'ulgm_current_managed_group_id' ).value
				];

				// Add the Group name
				let groupName = $( "#group-id option:selected" ).text();
				groupName = groupName ? groupName : $( "#group-name" ).text();
				filenameParts.push( groupName );

				return filenameParts.join( ' - ' );
			}
		};

		// Check what column has to be used to sort the table
		let enrolledUsersOrder = [];
		// Find the index of the column we have to use to sort
		let enrolledUsersOrderByIndex = userColumns.findIndex( columnData => columnData.title == ulgmGroupManagementShortcode.tables.enrolledUsers.orderBy );
		// If the column doesn't exist, then try to get the default one
		if ( enrolledUsersOrderByIndex === -1 ) {
			enrolledUsersOrderByIndex = userColumns.findIndex( columnData => columnData.targets == 'first_name' );
		}
		// If the one defined by the user, or the default one exists, add it
		if ( enrolledUsersOrderByIndex !== -1 ) {
			enrolledUsersOrder = [
				[
					enrolledUsersOrderByIndex, // The ID of the column used to sort, defaults to `first_name`
					ulgmGroupManagementShortcode.tables.enrolledUsers.order, // Designates the ascending or descending order of the ‘orderby‘ parameter, defaults to `asc`
				]
			];
		}

		let userTableVars = {
			data: this.data.ulgmGroupLeaderData.enrolled_user_data,
			searchDelay: 400,
			columns: userColumns,
			dom: '<"uo-groups-datatable-header"B>frt<"uo-groups-datatable-footer"lpi>',
			order: enrolledUsersOrder,
			pageLength: parseInt( this.$elements.enrolledUsersTableDT.data( 'page_length' ) ),
			lengthMenu: [
				[10, 25, 50, 100],
				[10, 25, 50, 100]
			],
			buttons: [
				$.extend( true, {}, buttonCommon, {
					extend: 'csv',
					text: ulgmRestApiSetup.language.buttons.csvExport,
					
				} ),
				$.extend( true, {}, buttonCommon, {
					extend: 'excelHtml5',
					text: ulgmRestApiSetup.i18n.exportExcel,
				} ),
			],
			language: {
				processing: ulgmRestApiSetup.language.processing,
				search: '_INPUT_',
				searchPlaceholder: ulgmRestApiSetup.language.searchPlaceholder,
				lengthMenu: ulgmRestApiSetup.language.lengthMenu,
				info: ulgmRestApiSetup.language.info,
				infoEmpty: ulgmRestApiSetup.language.infoEmpty,
				infoFiltered: ulgmRestApiSetup.language.infoFiltered,
				infoPostFix: '',
				loadingRecords: ulgmRestApiSetup.language.loadingRecords,
				zeroRecords: ulgmRestApiSetup.language.zeroRecords,
				emptyTable: ulgmRestApiSetup.language.emptyTable,
				paginate: {
					first: ulgmRestApiSetup.language.paginate.first,
					previous: ulgmRestApiSetup.language.paginate.previous,
					next: ulgmRestApiSetup.language.paginate.next,
					last: ulgmRestApiSetup.language.paginate.last
				},
				aria: {
					sortAscending: ulgmRestApiSetup.language.sortAscending,
					sortDescending: ulgmRestApiSetup.language.sortDescending
				}
			},
			processing: false,
			serverSide: false,

			createdRow: function( row, data, dataIndex ){
				$( row )
					.addClass( `status_id-${ data.status_id }` )
			},

			initComplete: () => {
				// Get the export CSV button
				const $fakeExportCSV = document.getElementById( 'group-management-users-export-csv' );

				// Get the export Excel button
				const $fakeExportExcel = document.getElementById( 'group-management-users-export-excel' );

				// Check if the element exists
				if ( document.body.contains( $fakeExportCSV ) ){
					// Add an event listener to listen clicks
					$fakeExportCSV.addEventListener( 'click', () => {
						// Click the real "Export CSV" button
						const $realExportCSV = document.querySelector( '#group-management-enrolled-users-datatable_wrapper .buttons-csv' );

						// Check if the element exists
						if ( document.body.contains( $realExportCSV ) ){
							// Click it
							const event = document.createEvent( 'HTMLEvents' );
							event.initEvent( 'click', true, false );
							$realExportCSV.dispatchEvent( event );
						}
					});
				}

				// Check if the element exists
				if ( document.body.contains( $fakeExportExcel ) ){
					// Add an event listener to listen clicks
					$fakeExportExcel.addEventListener( 'click', () => {
						// Click the real "Export CSV" button
						const $realExportExcel = document.querySelector( '#group-management-enrolled-users-datatable_wrapper .buttons-excel' );

						// Check if the element exists
						if ( document.body.contains( $realExportExcel ) ){
							// Click it
							const event = document.createEvent( 'HTMLEvents' );
							event.initEvent( 'click', true, false );
							$realExportExcel.dispatchEvent( event );
						}
					});
				}
			}
		};

		let userTable = null;

		// User table
		userTable = this.$elements.enrolledUsersTableDT.DataTable( userTableVars );

		$( document ).trigger( 'enrolledUsersTableDataTableCreated', {
			userTableVars: userTableVars,
			userTable: userTable,
			ulgmGroupLeaderData: ulgmGroupLeaderData
		} );

		let leaderColumns = this.data.ulgmGroupLeaderData.enrolled_leader_columns;
		if ('true' === this.data.ulgmGroupLeaderData.populate_management_features) {
			leaderColumns.unshift( {data: 'check', targets: 0, title: this.data.ulgmGroupLeaderData.check_all} );
		}

		// Check what column has to be used to sort the table
		let groupLeadersOrder = [];
		// Find the index of the column we have to use to sort
		let groupLeadersOrderByIndex = leaderColumns.findIndex( columnData => columnData.title == ulgmGroupManagementShortcode.tables.groupLeaders.orderBy );
		// If the column doesn't exist, then try to get the default one
		if ( groupLeadersOrderByIndex === -1 ) {
			groupLeadersOrderByIndex = leaderColumns.findIndex( columnData => columnData.data == 'first_name' );
		}
		// If the one defined by the user, or the default one exists, add it
		if ( groupLeadersOrderByIndex !== -1 ) {
			groupLeadersOrder = [
				[
					groupLeadersOrderByIndex, // The ID of the column used to sort, defaults to `first_name`
					ulgmGroupManagementShortcode.tables.groupLeaders.order, // Designates the ascending or descending order of the ‘orderby‘ parameter, defaults to `asc`
				]
			];
		}

		let leaderTableVars = {
			data: this.data.ulgmGroupLeaderData.enrolled_leader_data,
			columns: leaderColumns,
			columnDefs: [{
				targets: 0,
				searchable: false,
				orderable: false,
			}],
			dom: 'frt<"uo-groups-datatable-footer"lpi>',
			order: groupLeadersOrder,
			language: {
				processing: ulgmRestApiSetup.language.processing,
				search: '_INPUT_',
				searchPlaceholder: ulgmRestApiSetup.language.searchPlaceholder,
				lengthMenu: ulgmRestApiSetup.language.lengthMenu,
				info: ulgmRestApiSetup.language.info,
				infoEmpty: ulgmRestApiSetup.language.infoEmpty,
				infoFiltered: ulgmRestApiSetup.language.infoFiltered,
				infoPostFix: '',
				loadingRecords: ulgmRestApiSetup.language.loadingRecords,
				zeroRecords: ulgmRestApiSetup.language.zeroRecords,
				emptyTable: ulgmRestApiSetup.language.emptyTable,
				paginate: {
					first: ulgmRestApiSetup.language.paginate.first,
					previous: ulgmRestApiSetup.language.paginate.previous,
					next: ulgmRestApiSetup.language.paginate.next,
					last: ulgmRestApiSetup.language.paginate.last
				},
				aria: {
					sortAscending: ulgmRestApiSetup.language.sortAscending,
					sortDescending: ulgmRestApiSetup.language.sortDescending
				}
			}
		};

		let leaderTable;

		// Try to set the custom page length and length menu attributes
		// This will work only if the user didn't override the uo-groups template
		// before Groups 3.7.3
		try {
			// Set custom page length
			leaderTableVars.pageLength = parseInt( this.$elements.enrolledLeaderTableDT.data( 'page_length' ) );

			// Set custom page length
			leaderTableVars.lengthMenu = this.$elements.enrolledLeaderTableDT.data( 'length_menu' );

			// Leader table
			leaderTable = this.$elements.enrolledLeaderTableDT.DataTable( leaderTableVars );
		} catch (e) {
			console.log( 'Beta: Could not set custom page length and custom menu length' );
			console.log( e );

			// Leader table
			leaderTable = this.$elements.enrolledLeaderTableDT.DataTable( leaderTableVars );
		}

		$( document ).trigger( 'enrolledLeaderTableDataTableCreated', {
			leaderTableVars: leaderTableVars,
			leaderTable: leaderTable,
			ulgmGroupLeaderData: ulgmGroupLeaderData
		} );
	}

	listenCheckboxToSelectAll(){
		// Listen changes to this checkbox
		this.$elements.container.on( 'change', '.group-management-enrolled-select-all', ( event ) => {

			// Get checkbox status
			const checkAllEl = $( event.currentTarget );
			const isChecked  = checkAllEl.is( ':checked' );

			// Get all checkboxes
			const $allCheckboxes = checkAllEl.closest( 'table' ).find( '.select-user' );

			// Check if it's checked
			if (isChecked) {
				// Select all users
				$allCheckboxes.prop( 'checked', true );
			} else {
				// Unselect all users
				$allCheckboxes.prop( 'checked', false );
			}

			// Get the current selected users
			this.updateSelectedUsers();

			// Evalute the visibility of the "Remove users" button
			this.evaluateRemoveUsersButtonVisiblity();

			// Evalute the visibility of the "Remove leaders" button
			this.evaluateRemoveLeadersButtonVisiblity();

			// Evaluate the visibility of the "Send emails" button
			this.evaluateSendEmailsButtonVisiblity();
		} );
	}

	listenCheckboxesChanges(){
		// Add event listener to the checkboxes
		this.$elements.container.on( 'change', 'input[type="checkbox"].select-user', ( event ) => {
			// Get the current selected users
			this.updateSelectedUsers();

			// Evalute the visibility of the "Remove users" button
			this.evaluateRemoveUsersButtonVisiblity();

			// Evalute the visibility of the "Remove leaders" button
			this.evaluateRemoveLeadersButtonVisiblity();

			// Evaluate the visibility of the "Send emails" button
			this.evaluateSendEmailsButtonVisiblity();
		} );
	}

	updateSelectedUsers(){
		// Create array to save selected users
		let selectedUsers   = [];
		let selectedLeaders = [];

		// Get all the checkboxes
		const $allUserCheckboxes   = this.$elements.enrolledUsersTableDT.find( 'input[type="checkbox"].select-user' );
		const $allLeaderCheckboxes = this.$elements.enrolledLeaderTableDT.find( 'input[type="checkbox"].select-user' );

		// Filter all checked and unchecked checkboxes
		const allCheckedCheckboxes = {
			users: $allUserCheckboxes.filter( ':checked' ),
			leaders: $allLeaderCheckboxes.filter( ':checked' ),
		};

		// Get the selected checkboxes
		$.each( allCheckedCheckboxes, ( type, $checkedCheckboxes ) => {
			$.each( $checkedCheckboxes, ( index, checkbox ) => {
				// Get the checkbox
				let $checkbox = $( checkbox );

				let $row = $checkbox.closest( 'tr' );

				if ('users' === type) {
					let status = $row.find( '.status' ).data( 'status' );

					let progressIsNotStarted;
					if ('not-started' === status) {
						progressIsNotStarted = 1;
					} else if ('not-enrolled' === status) {
						progressIsNotStarted = 1;
					} else {
						progressIsNotStarted = 0;
					}

					// Add data to the selectedUsers array
					selectedUsers.push( {
						userId: $checkbox.val(),
						progressIsNotStarted: progressIsNotStarted,
					} );
				}
				if ('leaders' === type) {
					// Add data to the selectedUsers array
					selectedLeaders.push( {
						userId: $checkbox.val()
					} );
				}
			} );
		} );

		// Update selected property
		this.selectedUsers   = selectedUsers;
		this.selectedLeaders = selectedLeaders;
	}

	evaluateRemoveUsersButtonVisiblity(){
		// Create the variable we're going to use to finally
		// decide if we have to show or not the button
		let showRemoveUsersButton = false;

		// Check if there are selected rows
		if (this.selectedUsers.length > 0) {
			// Check if the option to remove users is enabled
			if (this.data.canRemoveUsers) {
				// Check if they can remove users anytime
				if (this.data.canRemoveUsersAnytime) {
					// Set variable to true to show the button later
					showRemoveUsersButton = true;
				} else {
					// Check the progress status of the selected users
					// To do that, first set the main variable to true
					// We're going to iterate each selected row and if
					// at least of the checks fail we're going to set
					// it back to false
					showRemoveUsersButton = true;

					// iterate each one
					this.selectedUsers.forEach( ( user ) => {
						// Check if the progress is "Not started"
						showRemoveUsersButton = showRemoveUsersButton && user.progressIsNotStarted;
					} );
				}
			}
		}

		// Now show or hide the button
		if (showRemoveUsersButton) {
			// Show the button
			this.$elements.removeUsersButton.show();
		} else {
			// Hide the button
			this.$elements.removeUsersButton.hide();
		}
	}

	evaluateRemoveLeadersButtonVisiblity(){
		// Create the variable we're going to use to finally
		// decide if we have to show or not the button
		let showRemoveLeadersButton = false;

		// Check if there are selected rows
		if (this.selectedLeaders.length > 0) {
			showRemoveLeadersButton = true;
		}

		// Now show or hide the button
		if (showRemoveLeadersButton) {
			// Show the button
			this.$elements.removeLeadersButton.show();
		} else {
			// Hide the button
			this.$elements.removeLeadersButton.hide();
		}

		// Add amount of users being removed to modal
		$( '.amount-group-leaders' ).text( this.selectedLeaders.length );

		let groupLeaderIds = [];
		$.each( this.selectedLeaders, ( index, user ) => {
			groupLeaderIds.push( user.userId );
		} );

		// Add all ids to button
		$( '#removing-group-leaders' ).val( groupLeaderIds.join( "," ) );
	}

	evaluateSendEmailsButtonVisiblity(){
		// For this one, just check if there are selected users
		if (this.selectedUsers.length > 0) {
			// Show the button
			this.$elements.sendEmailsButton.show();
		} else {
			// Hide the button
			this.$elements.sendEmailsButton.hide();
		}
	}

	updateDataOnModal(){
		// Listen when the modal is being opened
		this.$elements.container.on( 'modal-open', ( event, modalId, modal ) => {

			// Create an array with the list of users
			const selectedUsers = this.selectedUsers.map( ( user ) => {
				return user.userId;
			} );

			// Update number of users selected users
			this.$elements.numberOfUsers.text( selectedUsers.length );


			// Check if the modal id the the ID of the "Send emails" modal
			if (modalId == '#group-management-enrolled-users-table-send-password-modal') {
				// Add the array as a string to a hidden field inside the Send password reset modal
				this.$elements.sendEmailsField.val( JSON.stringify( selectedUsers ) );
			} else if (modalId == '#group-management-remove-user') {

				// Create a comma separated list with the IDs
				const userIds = selectedUsers.join( ',' );

				// Add the list of IDs on a hidden field
				this.$elements.removeUsersField.val( userIds );
			}
		} );
	}

	hasEnrolledUsersTable(){
		return $( '#group-management-enrolled-users-datatable' ).length == 1;
	}

	/**
	 * Make the First and Last name fields of the "Bulk add & Invite users" required
	 * Logic: Listen when the user types in one of the "Email" fields.
	 * If the Email is not empty,
	 * > Make First name and Last name fields required
	 * 
	 */
	firstLastNamesRequired() {
		// Check if we have to make them required first
		if ( ! ulgmGroupManagementShortcode.firstnameLastnameRequired ) {
			return;
		}

		// Create array with main CSS selectors
		const requiredSelectors = {
			emailFields: '#group-management-add-users .content-leaders-email input',
			firstName: '.content-leaders-first-name input',
			lastName: '.content-leaders-last-name input',
			row: '.uo-row',
			rowWithData: 'group-management-add-users-row--with-data'
		}

		// Get all the email fields
		const $emailFields = document.querySelectorAll( requiredSelectors.emailFields );

		// Iterate fields
		$emailFields.forEach( ( $emailField ) => {
			// Listen changed to the field
			// Execute the callback up to once every 200ms
			$emailField.addEventListener(
				'input',
				debounce( () => {
					// Get the field value
					const emailValue = $emailField.value;

					// If it's not empty, make First name and Last name required
					// First, get the row and fields
					const $rowElements = {
						row: $emailField.closest( requiredSelectors.row )
					}

					$rowElements.firstName = $rowElements.row.querySelector( requiredSelectors.firstName );
					$rowElements.lastName  = $rowElements.row.querySelector( requiredSelectors.lastName );
					
					// Check if it's empty
					if ( isEmpty( emailValue ) ) {
						// Remove the class used to identify rows with data
						$rowElements.row.classList.remove( requiredSelectors.rowWithData );

						// Make the fields optional
						$emailField.removeAttribute( 'required' )
						$emailField.setAttribute( 'placeholder', ulgmRestApiSetup.i18n.emailAddress );

						$rowElements.firstName.removeAttribute( 'required' )
						$rowElements.firstName.setAttribute( 'placeholder', ulgmRestApiSetup.i18n.firstName );

						$rowElements.lastName.removeAttribute( 'required' )
						$rowElements.lastName.setAttribute( 'placeholder', ulgmRestApiSetup.i18n.lastName );
					} else {
						// Add the class used to identify rows with data
						$rowElements.row.classList.add( requiredSelectors.rowWithData );

						// Make the fields optional
						$emailField.setAttribute( 'required', '' );
						$emailField.setAttribute( 'placeholder', `${ ulgmRestApiSetup.i18n.emailAddress } *` );

						$rowElements.firstName.setAttribute( 'required', '' );
						$rowElements.firstName.setAttribute( 'placeholder', `${ ulgmRestApiSetup.i18n.firstName } *` );

						$rowElements.lastName.setAttribute( 'required', '' );
						$rowElements.lastName.setAttribute( 'placeholder', `${ ulgmRestApiSetup.i18n.lastName } *` );
					}
					
				}, 200 )
			);
		} );
	}
}

export default GroupManagement;
